<template>
    <div>
        <CuentaAtras @tiempoTerminado="tiempoTerminado"/>
        <PageTitle 
            :title="$t('nuevo_abono.titulo', { temporada: lista_abonados.nombre, abono: teatro.texto_abono })" 
            class="strech"
        />
        <section class="padding-vertical-content">
            <Stepper 
                ref="stepper"
                :steps="steps" 
            >
                <template #pasoSector="{ changeStep }">
                    <SeleccionarZonaComponent
                        @zonaSeleccionada="(zona) => { 
                            zona_seleccionada = zona; 
                            changeStep(); 
                        }"
                    />                   
                </template>
                <template #pasoAsiento="{ changeStep }">
                    <SeleccionarAsientosSga
                        :zona="zona_seleccionada"
                        @volver="() => {
                            zona_seleccionada = null;
                            changeStep(true);
                        }"
                    />                
                </template>
            </Stepper>
        </section>
    </div>
</template>

<script>
import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
import PageTitle from '@/components/frontend/shared/PageTitle';
import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
import SeleccionarZonaComponent from './SeleccionarZonaComponent.vue';
import SeleccionarAsientosSga from './SeleccionarAsientosSga.vue';

export default {
    data() {
        return {
            steps: [
                { label: "Seleccionar sector", slot: "pasoSector" },
                { label: "Seleccionar asientos", slot: "pasoAsiento" },
            ],
            zona_seleccionada: null
        }
    },
    computed: {
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
        teatro(){
            return this.$store.getters.getTeatro
        }
    },
    methods: {
        tiempoTerminado() {
            alert('Volver');
        },
    },
    components: {
        CuentaAtras, PageTitle, Stepper, SeleccionarZonaComponent, SeleccionarAsientosSga
    }
}
</script>